import { render, staticRenderFns } from "./sctterMap.vue?vue&type=template&id=05cc8cba&scoped=true"
import script from "./sctterMap.vue?vue&type=script&lang=js"
export * from "./sctterMap.vue?vue&type=script&lang=js"
import style0 from "./sctterMap.vue?vue&type=style&index=0&id=05cc8cba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05cc8cba",
  null
  
)

export default component.exports